export const ACCOUNTING_PERIODS_KEY = 'AccountingPeriods';
export const ACCOUNTING_PERIOD_METADATA_KEY = 'AccountingPeriodMetadata';
export const ACCOUNTING_PERIOD_CONFIG_KEY = 'AccountingPeriodConfiguration';

export const ACCOUNTING_PERIOD_BASE_PATH = '/AccountingPeriod';
